import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
* {
  outline: none;
  box-sizing: border-box;
  margin: 0;
}

html, input, select, textarea, button {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  color: #2b2b2b;
}

body {
  line-height: 1.3;
  background-color: rgb(245,245,245);
}

ul {
  padding: 0
}

`;

export default GlobalStyle;
